import { checkResponse } from "./utils";

// function to handle reset of database
export async function resetDatabase(user, logout) {
  const updateCleanerResponse = await fetch(`${process.env.REACT_APP_BACKEND_URL}/streck/reset`, {
    headers: {
      Authorization: `Bearer ${user.token}`,
    },
  });
  if (!await checkResponse(updateCleanerResponse, logout)) return false;
}
